import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';
import { surpriseService } from '@/services/surprise';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useSurpriseItemEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        categoryId: StringUtils.toNumber(route.params.categoryId),
        id: StringUtils.toNumber(route.params.itemId),
        name: '',
        price: 0,
        isPublished: false,
        image: null,
        imageStatus: null,
        imageFile: null
    });

    const validations = {
        name: { required },
        isPublished: { required },
        imageFile: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => surpriseService.item.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () =>
            router.push({ name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.INDEX, params: { categoryId: model.categoryId } })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                surpriseService.item.update(model.id, model.name, model.price, model.isPublished, model.imageFile),
            onSuccess: () =>
                router.push({ name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.INDEX, params: { categoryId: model.categoryId } })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => surpriseService.item.remove(model.id),
            onSuccess: () =>
                router.push({ name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.INDEX, params: { categoryId: model.categoryId } })
        })
    };

    return { model, v$, fetch, actions };
}
